import { DeliveryTypeCategory } from '@/features/orders/constants/app'

const primaryOrder: DeliveryTypeCategory[] = [
    DeliveryTypeCategory.EatIn,
    DeliveryTypeCategory.Takeaway,
    DeliveryTypeCategory.Delivery,
]

export const sortDeliveryTypeCategoriesVisualOrder = (
    deliveryTypeCategories: DeliveryTypeCategory[]
): DeliveryTypeCategory[] => {
    const primaryDeliveryTypeCategories = primaryOrder.filter((deliveryTypeCategory) =>
        deliveryTypeCategories.includes(deliveryTypeCategory)
    )
    const extraDeliveryTypeCategories = deliveryTypeCategories.filter(
        (deliveryTypeCategory) => !primaryDeliveryTypeCategories.includes(deliveryTypeCategory)
    )

    return [...primaryDeliveryTypeCategories, ...extraDeliveryTypeCategories]
}
